module.exports = __webpack_public_path__ + "img/int-black.24bf17bb.svg";